import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("modolo-lang") || "es";
  });

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "es" ? "en" : "es";
      localStorage.setItem("modolo-lang", next);
      return next;
    });
  }, []);

  const setLanguage = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem("modolo-lang", newLang);
  }, []);

  const t = useCallback(
    (key) => {
      const dict = translations[lang] || translations.es;
      const value = key.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : null), dict);
      if (value === null || value === undefined) {
        // fallback to spanish
        return key.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : key), translations.es);
      }
      return value;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, toggle, setLanguage, t }), [lang, toggle, setLanguage, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
